module.exports = __webpack_public_path__ + "static/media/dw-blue.87baa688.svg";